import { useContext } from "react";
import { EditorContext } from "../contexts";

const useEditor = () => {
  return useContext(EditorContext);
};
export default useEditor;
